/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CopyText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CopyText({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/CopyAction/Content/Content/CopyText"
  
}) {
let tabSelectedAutomationsValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.automations',
format: fromHelpers.formatCopyText,
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceM}
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral400}
 data="tab.selected.automations"
 format="helpers.js formatCopyText"
 text={tabSelectedAutomationsValueData}
/>
{children}
</React.Fragment>)
}